"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ErrorPage_1 = __importDefault(require("./ErrorPage"));
function withOnlineListener(WrappedComponent) {
    return class extends React.Component {
        constructor() {
            super(...arguments);
            this.state = {
                isOnline: navigator.onLine
            };
            this.handleOnline = () => {
                this.setState({ isOnline: navigator.onLine });
            };
        }
        componentDidMount() {
            window.addEventListener("online", this.handleOnline, false);
            window.addEventListener("offline", this.handleOnline, false);
        }
        componentWillUnmount() {
            window.removeEventListener("online", this.handleOnline, false);
            window.removeEventListener("offline", this.handleOnline, false);
        }
        render() {
            if (this.state.isOnline) {
                return React.createElement(WrappedComponent, null);
            }
            return React.createElement(ErrorPage_1.default, { type: "errConnection" });
        }
    };
}
exports.default = withOnlineListener;
//# sourceMappingURL=withOnlineListener.js.map